var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlace = function SvgPlace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillOpacity: 0.44,
    d: "M6 0A5.6 5.6 0 0 0 .4 5.6C.4 9.8 6 16 6 16s5.6-6.2 5.6-10.4C11.6 2.508 9.092 0 6 0m0 7.6a2 2 0 1 1 .001-4.001A2 2 0 0 1 6 7.6"
  })));
};
export default SvgPlace;